module.exports = __webpack_public_path__ + "static/img/invisto.11100ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/invisto.svg
// module id = HsiR
// module chunks = 1